import gql from "graphql-tag";

import { Fragment, TemplateQuestion } from "../types";

import { SKILL_FRAGMENT } from "./Skill";
import { UserMinimalFragment, USER_MINIMAL_FRAGMENT } from "./User";

export const TEMPLATE_QUESTION_FRAGMENT = gql`
  fragment TemplateQuestionFragment on TemplateQuestion {
    id
    label
    description
    referents {
      ...UserMinimalFragment
    }
    order
    reportTypes
    defaultValue
    defaultValueSchema
    options
    optionsSchema
    timeTracked
    type
    digest
    subjectId
    subjectType
    expectedTimeValue
    expectedTimeUnit
    subject {
      ... on Skill {
        ...SkillFragment
      }
    }
  }

  ${USER_MINIMAL_FRAGMENT}
  ${SKILL_FRAGMENT}
`;

export type TemplateQuestionFragment = Fragment<
  TemplateQuestion,
  Omit<TemplateQuestion, "referents"> & {
    referents: UserMinimalFragment[];
  }
>;
